import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { DvfPropertyType } from '@app/shared';
import { fetchCommuneDvf, searchCommunes } from './api';

const dvfKey = (code: string, propertyType: DvfPropertyType) => ['market', 'dvf', code, propertyType] as const;

/** Sans saisie suffisante, aucun appel : la source publique n'est sollicitée que sur une vraie recherche. */
export function useCommuneSearch(query: string) {
  return useQuery({
    queryKey: ['market', 'communes', query],
    queryFn: () => searchCommunes(query),
    enabled: query.length >= 2,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export function useCommuneDvf(code: string | null, propertyType: DvfPropertyType) {
  return useQuery({
    queryKey: dvfKey(code ?? '', propertyType),
    queryFn: () => fetchCommuneDvf(code!, propertyType, false),
    enabled: code !== null,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
}

/** Retélécharge les fichiers DVF et remplace le résultat affiché. */
export function useRefreshCommuneDvf(code: string | null, propertyType: DvfPropertyType) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => fetchCommuneDvf(code!, propertyType, true),
    onSuccess: (data) => queryClient.setQueryData(dvfKey(code!, propertyType), data),
  });
}
